import BigNumber from "bignumber.js";
import { BUILD_TARGET } from "../globals";

// Utility functions
export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const range = (n: number) =>
  Array.from({ length: n }, (value, key) => key);

export const getQueryVariablesFromURL = (url) => {
  const urlSplit = url.split("?");
  const query = urlSplit[1];
  const vars = query ? query.split("&") : [];
  const varDic = {};
  for (const v of vars) {
    const pair = v.split("=");
    const key = decodeURIComponent(pair[0]);
    const val = decodeURIComponent(pair[1]);
    varDic[key] = val;
  }
  return {
    base: urlSplit[0],
    variables: varDic,
  };
};

export const getUrlQueryFromDictionary = (queryObject) => {
  const paramArray = Object.keys(queryObject)
    .map((key) => {
      if (queryObject[key]) {
        return `${key}=${queryObject[key]}`;
      }
    })
    .filter((v) => v);
  return `?${paramArray.join("&")}`;
};

export const currencyRegEx = /^[1-9]\d{0,19}(\.\d{1,18})?|0+\.\d{1,18}$/;

export const setLocal = (key: string, val: any) => {
  localStorage.setItem(key, JSON.stringify(val));
};

export const getLocal = (key: string) => {
  const strVal = localStorage.getItem(key);
  if (!strVal) {
    return;
  }
  return JSON.parse(strVal);
};

export const clearLocal = (key: string) => {
  localStorage.removeItem(key);
};

export const fpsConuter = (store) => {
  const oneSec = 1000;
  const times: number[] = [];
  let fps;
  function refreshLoop() {
    window.requestAnimationFrame(() => {
      const now = performance.now();
      while (times.length > 0 && times[0] <= now - oneSec) {
        times.shift();
      }
      times.push(now);
      fps = times.length;
      refreshLoop();
    });
  }
  refreshLoop();
  setInterval(() => store.commit("fps", fps), oneSec);
};

function styleEl(el, styles, enabled = true) {
  Object.keys(styles).forEach((key) => {
    el.style[key] = enabled ? styles[key] : "";
  });
}

function onAnimationComplete(elem, resolve) {
  elem.removeEventListener("transitionend", onAnimationComplete);
  if (resolve) {
    resolve();
  }
}

export const animate = async (
  el,
  style,
  options: any = {},
  promise = true,
) => {
  options = {
    time: 300,
    ease: "ease-in-out",
    ...options,
  };

  const transitions: string[] = [];
  Object.keys(style).forEach((key) => {
    transitions.push(`${key} ${options.time}ms ${options.ease}`);
  });

  el.style.transition = transitions.join(", ");

  if (promise) {
    return new Promise((resolve, reject) => {
      el.addEventListener(
        "transitionend",
        (e) => {
          e.stopPropagation();
          onAnimationComplete(el, resolve);
        },
        false,
      );
      styleEl(el, style);
    });
  } else {
    styleEl(el, style);
  }
};

export const openWindowWithPost = (url, data: any = {}, target = "_self") => {
  const form = document.createElement("form");
  form.target = target;
  form.method = "POST";
  form.action = url;
  form.style.display = "none";

  for (const key of Object.keys(data)) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = data[key];
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const areEquals = (objA, objB) => {
  const encA = JSON.stringify(objA);
  const encB = JSON.stringify(objB);
  return encA === encB;
};

export const isAsobiWallet = () => /AsobiWallet/.test(navigator.userAgent);

export const isDiselApplication = () =>
  /DiselApplication/.test(navigator.userAgent);

export const isInAppWebView = () => isDiselApplication() || isAsobiWallet();

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isAndroid = () => /Android/.test(navigator.userAgent);

export const isIOSWallet = () => isIOS() && isAsobiWallet();
export const isIOSDiselApplication = () => isIOS() && isDiselApplication();

export const isAdultDisabled = () => {
  if (BUILD_TARGET === "BOOK_VIEWER") {
    return true;
  }
  return isIOSWallet() || isIOSDiselApplication();
};

export const toCurrency = (amount, currency, precision = 0) => {
  const point = new BigNumber(amount);

  // 1.000000 -> 1
  // 0.123456789 -> 0.12345678
  const formatted =
    point.decimalPlaces() < precision
      ? point.toFormat()
      : point.toFormat(precision, BigNumber.ROUND_FLOOR);
  return `${formatted} ${currency}`;
};

export const formatString = (str, obj) =>
  str.replace(/(\[\w+\])/g, function(all, group) {
    return obj[group];
  });

let canvas: HTMLCanvasElement | undefined;

export function getTextMetrics(text, font) {
  canvas = canvas || document.createElement("canvas");
  const context = (canvas as any).getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics;
}

export function hideMainSpinner() {
  const spinnerWrapper = document.body.querySelector(".spinner-wrapper");
  if (spinnerWrapper) {
    spinnerWrapper.remove();
  }
}
